import React, { FC, useEffect, useState, Dispatch, SetStateAction } from 'react';
import copy from 'copy-to-clipboard';
import toast from 'react-hot-toast';
import { cloneDeep, isUndefined } from 'lodash';

import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { setTiers } from '../redux/reducers/tier.slice';

import MuxHelper from '../utils/MuxHelper';
import { ReactComponent as CopyIconSVG } from '../svg/copy-icon.svg';

type MediaProps = {
  media: Media;
};

const muxHelper = new MuxHelper();

const Media: FC<MediaProps> = ({ media }) => {
  const dispatch = useAppDispatch();
  const [poster, setPoster] = useState<null | string>(null);
  const [hoverTierIndex, setHoverTierIndex] = useState<number>(-1);

  // const [isPublish, setPoster] = useState<null | string>(null);

  const tiers = useAppSelector((state) => state.tier.value);

  useEffect(() => {
    if (!media) return;

    async function fetchPoster() {
      const { poster } = await muxHelper.fetchSourceByAssetId(media.muxAssetsId);
      if (poster) setPoster(poster);
    }

    fetchPoster();
  }, [media]);

  const handleMouseHover = (value: number) => {
    setHoverTierIndex(value);
  };

  function copyMediaURL(tokenId: number | undefined, mediaId: number | undefined) {
    if (!tokenId || !mediaId) return;

    const mediaURL = `${location.origin}/${tokenId}/${mediaId}`;

    copy(mediaURL);

    toast.success('Copied');
  }

  function onChangeTier(checked: boolean, tier: Tier, media: Media) {
    const newTiers = cloneDeep(tiers);

    const currentTierIdx = newTiers.findIndex((item) => item.id === tier.id);

    if (currentTierIdx !== -1) {
      if (checked) {
        newTiers[currentTierIdx]?.medias?.push(media);
      } else {
        const currentMediaInTierIdx = tiers[currentTierIdx]?.medias?.findIndex((item) => item.id === media.id);

        if (!isUndefined(currentMediaInTierIdx) && currentMediaInTierIdx !== -1) {
          newTiers[currentTierIdx].medias?.splice(currentMediaInTierIdx, 1);
        }
      }
    }

    dispatch(setTiers(newTiers));
  }

  return (
    <div className="media">
      <div className="media--item">
        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: 8 }}>
          <div>
            <input type="checkbox" checked={selectedMedia?.id === media?.id} onChange={() => onChange(media)} />
          </div>
        </div> */}
        <div className="media--item-img">
          <img src={poster || '/poster.png'} />
        </div>
        <div className="media--item-info">
          <div>{media.title}</div>
          <div>{media.description || 'No description'}</div>
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          {tiers?.map((tier: Tier, index) => (
            <div
              key={tier.id || index}
              className="media--item-tier"
              onMouseEnter={() => handleMouseHover(index)}
              onMouseLeave={() => handleMouseHover(-1)}
            >
              <div className="media--item-tier-name" style={{ marginBottom: 8 }}>
                {tier.name}
              </div>
              <div>
                <input
                  type="checkbox"
                  checked={!!tier?.medias?.find((item) => item?.id === media?.id)}
                  onChange={(e) => onChangeTier(e.target.checked, tier, media)}
                />
              </div>

              <div
                style={{
                  width: 36,
                  height: 36,
                  marginTop: 10,
                }}
                onClick={() => copyMediaURL(tier?.tokenId, media?.id)}
              >
                {/* {hoverTierIndex === index && !!tier?.medias?.find((item) => item?.id === media?.id && tier.published) && ( */}
                {!!tier?.medias?.find((item) => item?.id === media?.id && tier.published) && (
                  <CopyIconSVG
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        {/* {tiers.find((item) => item?.published && item.medias?.map((item) => item.id).includes(media.id)) && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: 'calc(50% - 14px)',
              cursor: 'pointer',
            }}
            onClick={copyMediaURL}
          >
            <CopyIconSVG />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Media;
